import React, { useState } from 'react'
import {
    Autocomplete,
    Backdrop,
    Box,
    Button,
    CircularProgress,
    Grid,
    MenuItem,
    TextField,
    Snackbar,
    Alert, AlertTitle,
    Collapse,
    Typography
} from "@mui/material";

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { VisibilityOff, Visibility, Close } from '@mui/icons-material';

import regex from "../../regex.json"

import axios from "axios";
import config from "../../config.json"

import { Routes, Route, useNavigate, Navigate, useParams } from "react-router-dom";

import profile from '../../assets/niced.png'
import rmrc from '../../assets/rmrc.png'
import Footer from '../Footer'

import { toast, ToastContainer } from "react-toastify";

import { useDispatch } from 'react-redux';
import { setAuthToken } from '../redux/actions';
import { disableBackButton } from '../ConstantComponents/Constants'


import CloseIcon from '@mui/icons-material/Close';

import '../../customcss/loadernew.css'




import Stack from '@mui/material/Stack';

const BASE_URL = config.SERVER_URL

export default function IcmrDashboardLogin() {

    const navigate = useNavigate();



    const [backdropopen, setbackdropopen] = useState(false);

    const [isLogin, setisLogin] = useState(false)


    const [showPassword, setshowPassword] = useState(false)

    const [email, setemail] = useState("")
    const [erremailb, seterremailb] = useState(false)
    const [erremail, seterremail] = useState("")

    const [password, setpassword] = useState("")
    const [errpasswordb, seterrpasswordb] = useState(false)
    const [errpassowrd, seterrpassowrd] = useState("")

    const [snackopen, setsnackopen] = useState(false)
    const [snackmessage, setsnackmessage] = useState('')
    const [snacklevel, setsnacklevel] = useState('success')

    const [alertmessage, setalertmessage] = useState("")

    const [alert, setalert] = useState(false)

    const style2 = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: 'auto',
        maxHeight: '100vh',
        transform: 'translate(-50%, -50%)',
        overflowY: 'auto',
        margin: 'auto',
        marginTop: 5,
        display: "flex",
        flexDirection: "row",
        border: "1px solid",
        padding: "20px",
        borderRadius: '20px',


    }

    const handleClickShowPassword = () => {
        if (showPassword === false) {

            setshowPassword(true)

        } else {

            setshowPassword(false)

        }
    }

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setsnackopen(false)
    }

    const handleloginClick = async () => {

        const params = new URLSearchParams();

        params.append("email", email);
        params.append("password", password)

        if (validation()) {

            setbackdropopen(true)

            //////console.log("login clicked")

            axios.post(BASE_URL+"/auth/dashboardLogin",
                params, { withCredentials: true }
            )
                .then(response => {
                    ////console.log("login", response);
                    //////console.log("headers", response.headers);
                    //////console.log("cust header", response.headers.authtoken);
                    if (response.status == 200) {

                        setbackdropopen(false)

                        //console.log("resp code: ", response.status)

                        //console.log("resp: ", response.data)

                        //console.log("headers: ", response.headers)

                        if (response.data.status === true) {

                            setbackdropopen(false)

                            sessionStorage.setItem('sessionid', response.headers.authtoken);
                           
                            navigate(response.data.redirectview.url)
                            

                        } else {
                            setbackdropopen(false)
                            setalertmessage(response.data.message)
                            setalert(true)
                        }




                        // setbackdropopen(false)
                        // sessionStorage.setItem('sessionid', response.headers.authtoken);
                        // //dispatch(setAuthToken(response.headers.authtoken));
                        // navigate(response.data.url)
                    } else {


                        setalertmessage("Error While Loggin In")
                        setalert(true)
                        setbackdropopen(false)
                    }

                })
                .catch(error => {

                    setalertmessage("Error While Loggin In")
                    setalert(true)
                    setbackdropopen(false)
                });

        }




    }

    function validation() {
        let isValid = true;

        if (email === "") {
            seterremailb(true)
            seterremail("Please Enter Email")
            isValid = false;
        } else if (!email.match(regex.emailpattern)) {
            seterremailb(true)
            seterremail("Please Enter Valid Email")
            isValid = false;
        } else {
            seterremailb(false)
            seterremail("")
        }

        if (password === "") {
            seterrpasswordb(true)
            seterrpassowrd("Please Enter Password")
            isValid = false;
        } else {
            seterrpasswordb(false)
            seterrpassowrd("")
        }

        return isValid;

    }


    return (
        <>
            <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box
                    sx={style2}
                    noValidate
                    autoComplete="off"
                >


                    <Grid container spacing={1} sx={{ padding: 5 }}>
                        <div className="container" style={{ textAlign: 'center', marginBottom: '15px' }}>
                            <h4 className="rubik-font"
                                style={{ color: "black", fontWeight: "lighter", textAlign: 'center' }}> Dashboard Login</h4>

                        </div>
                        <Grid item xs={12} md={12} lg={12}>
                            <div style={{ marginBottom: '20px' }}>
                                <Collapse in={alert}>
                                    <Alert action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setalert(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    } severity="error">
                                        <AlertTitle>Error</AlertTitle>
                                        <Typography variant='body1'>{alertmessage}</Typography>
                                    </Alert>
                                </Collapse>

                            </div>
                        </Grid>


                        <Grid item xs={12} md={12} lg={12} >
                            <div>
                                <TextField
                                    error={erremailb}
                                    helperText={erremail}
                                    fullWidth
                                    label="Email"
                                    value={email}
                                    onChange={
                                        (e) => setemail(e.target.value)
                                        //setdistrict(centers.filter(op => op.center_dist_id === district))
                                    }

                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField
                                    error={errpasswordb}
                                    helperText={errpassowrd}
                                    fullWidth
                                    label="Password"
                                    value={password}
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={
                                        (e) => setpassword(e.target.value)
                                        //setdistrict(centers.filter(op => op.center_dist_id === district))
                                    }
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    //onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}


                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5, alignItems: 'center', justifyContent: 'center', display: 'grid' }}>
                            <Button variant="contained" onClick={handleloginClick}>Login</Button>

                        </Grid>
                    </Grid>
                </Box>
            </div>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackopen} autoHideDuration={6000} onClose={handleSnackClose}>
                <Alert

                    onClose={handleSnackClose}
                    severity={snacklevel}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {snackmessage}
                </Alert>
            </Snackbar>

            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.8)' }}
                open={backdropopen}
            >
                {/* <CircularProgress color="inherit" /> */}
                <div class="boxes">
                    <div class="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </Backdrop>

        </>
    )
}
